import React, { FunctionComponent } from 'react'
import { cn } from 'ethcss'
import { stepsStyles } from './Steps-styles'
import { IStepsComponent, IStepsElement, IStepsElementProps } from './Steps-types'

const StepsComponent: FunctionComponent<IStepsComponent> = ({
    className,
    contentClassName,
    active,
    children,
    mod = 'default',
}) => {
    const modifyChildren = (child: IStepsElement) => {
        const className = cn(child.props.className, contentClassName, stepsStyles.Steps__content, {
            [stepsStyles[`Steps__content_${mod}_activated`]]: active === child.props.id,
            [stepsStyles[`Steps__content_${mod}_disabled`]]: active !== child.props.id,
        })

        const props = {
            ...child.props,
            className,
        }

        return React.cloneElement(child, props)
    }

    return (
        <div className={cn(className, stepsStyles.Steps)}>
            {children &&
                React.Children.count(children) > 0 &&
                React.Children.map(children, (child) =>
                    React.isValidElement<IStepsElementProps>(child) ? modifyChildren(child) : child
                )}
        </div>
    )
}

export const Steps = React.memo(StepsComponent)
